import { useEffect } from "react";
import { Link } from "react-router-dom";
import { C, HEADSHOT } from "../data/content";

export default function ThankYou() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-6 py-24" data-testid="thank-you-page">
      <div className="max-w-[640px] w-full text-center">
        <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center text-4xl font-black text-white mb-8"
          style={{ background: "var(--accent)", boxShadow: "0 0 80px rgba(68,76,231,0.45)" }}>✓</div>
        <p className="mono text-[11px] tracking-[0.3em] text-[var(--accent)] mb-4">YOU'RE IN — SEAT CONFIRMED</p>
        <h1 className="h1-display text-[clamp(32px,4.5vw,56px)] mb-6">THANK YOU.<br />YOUR SPOT IS <span className="text-[var(--accent)]">RESERVED.</span></h1>
        <p className="text-[15px] text-white/55 leading-relaxed max-w-[480px] mx-auto mb-10">
          Check your email and phone — confirmation details are on the way. Check your email and phone — confirmation details are on the way for your chosen session: <span className="text-[var(--accent)] font-bold">Tuesday, October 27 or Thursday, October 29, 2026 at 7:30 PM Eastern</span>. No spam, no obligation, no hard credit pull.
        </p>
        <div className="glass-card p-6 flex items-center gap-4 max-w-[400px] mx-auto mb-10 text-left">
          <img src={HEADSHOT} alt="Darren Gussick" className="w-[52px] h-[52px] rounded-full object-cover border-2 shrink-0" style={{ borderColor: "var(--accent)" }} />
          <div>
            <p className="text-sm font-bold">{C.hostName}</p>
            <p className="text-[11px] text-white/40">{C.hostCompany} · NMLS# {C.hostNmls}</p>
            <p className="text-[11px] text-white/40">407-550-5795 · dgussick@nexalending.com</p>
          </div>
        </div>
        <Link to="/" className="btn-outline cta inline-block" data-testid="thank-you-home-link">← BACK TO HOME</Link>
        <p className="text-[10px] text-white/25 mt-10">{C.microTrust}</p>
      </div>
    </div>
  );
}
